// @flow
import React, { Fragment } from 'react';
import QuoteHead from 'components/quote/QuoteHead';
import QuoteContent from '../QuoteContent';
import './QuotePlaceholder.scss';

type Props = {};

const QuotePlaceholder = (props: Props) => (
  <Fragment>
    <QuoteHead.Placeholder />
    <QuoteContent.Placeholder />
  </Fragment>
);

export default QuotePlaceholder;



// WEBPACK FOOTER //
// ./src/components/quote/QuotePlaceholder/QuotePlaceholder.js